import { styled } from '@mui/material';

export const HeaderInfoStyled = styled('div')({
  display: 'flex',
  gap: 2,
  marginBottom: '4px',
  '& .value': {
    color: '#008000',
  },
});
